import {
  Button,
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Theme,
  Tooltip,
} from "@fluentui/react-components";
import {
  Edit20Regular,
  Delete20Regular,
  Tag20Regular,
  TagMultiple20Regular,
} from "@fluentui/react-icons";
import { ApplicationUserDto } from "../../KulcsUzletSvc";
import { formatDate } from "../../utils/HelperFunctions";

export const columnSizingOptionsMerchants = {
  name: {
    minWidth: 120,
    defaultWidth: 250,
  },
  username: {
    minWidth: 120,
    defaultWidth: 250,
  },
  email: {
    minWidth: 150,
    defaultWidth: 250,
  },
  lastEditDate: {
    minWidth: 150,
    defaultWidth: 180,
  },
  couponCount: {
    minWidth: 100,
    defaultWidth: 120,
  },
  usedCouponCount: {
    minWidth: 120,
    defaultWidth: 150,
  },
  id: {
    minWidth: 180,
    defaultWidth: 220,
  },
};

export const getColumnsMerchants = (
  theme: Theme,
  handleRowAction: any,
  navigate: any
) =>
  [
    createTableColumn<ApplicationUserDto>({
      columnId: "name",
      renderHeaderCell: () => "Név",
      renderCell: (item: ApplicationUserDto) => {
        return (
          <TableCellLayout truncate>{item.fullName ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<ApplicationUserDto>),
    createTableColumn<ApplicationUserDto>({
      columnId: "username",
      renderHeaderCell: () => "Felhasználónév",
      renderCell: (item: ApplicationUserDto) => {
        return (
          <TableCellLayout truncate>{item.userName ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<ApplicationUserDto>),
    createTableColumn<ApplicationUserDto>({
      columnId: "email",
      renderHeaderCell: () => "Email",
      renderCell: (item: ApplicationUserDto) => {
        return (
          <TableCellLayout truncate>{item.emailAddress ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<ApplicationUserDto>),

    createTableColumn<ApplicationUserDto>({
      columnId: "lastEditDate",
      renderHeaderCell: () => "Utolsó módosítás dátuma",
      renderCell: (item: ApplicationUserDto) => {
        return (
          <TableCellLayout truncate>
            {formatDate(item.lastEditDate) ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ApplicationUserDto>),
    createTableColumn<ApplicationUserDto>({
      columnId: "couponCount",
      renderHeaderCell: () => "Kuponok száma",
      renderCell: (item: ApplicationUserDto) => {
        return (
          <TableCellLayout truncate>{item.couponCount ?? ""} </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ApplicationUserDto>),
    createTableColumn<ApplicationUserDto>({
      columnId: "usedCouponCount",
      renderHeaderCell: () => "Felhasználtak száma",
      renderCell: (item: ApplicationUserDto) => {
        return (
          <TableCellLayout truncate>
            {item.usedCouponCount ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ApplicationUserDto>),
    createTableColumn<ApplicationUserDto>({
      columnId: "id",
      renderHeaderCell: () => "Műveletek",
      renderCell: (item: ApplicationUserDto) => {
        return (
          <TableCellLayout truncate>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip
                content="Kereskedő adatainak módosítása"
                relationship="label"
              >
                <Button
                  style={{ backgroundColor: "#f0ad4e", color: "white" }}
                  icon={<Edit20Regular />}
                  onClick={() => navigate(`/admin/trader/edit/${item.id}`)}
                />
              </Tooltip>

              <Tooltip content="Kereskedő törlése" relationship="label">
                <Button
                  style={{ backgroundColor: "#d9534f", color: "white" }}
                  icon={<Delete20Regular />}
                  onClick={() =>
                    handleRowAction && handleRowAction("deleteMerchant", item)
                  }
                />
              </Tooltip>

              <Tooltip content="Kuponok listázása" relationship="label">
                <Button
                  style={{ backgroundColor: "#5bc0de", color: "white" }}
                  icon={<Tag20Regular />}
                  onClick={() => navigate(`/admin/trader/${item.id}/coupons`)}
                />
              </Tooltip>

              <Tooltip
                content="Felhasznált kuponok listázása"
                relationship="label"
              >
                <Button
                  style={{ backgroundColor: "#337ab7", color: "white" }}
                  icon={<TagMultiple20Regular />}
                  onClick={() => navigate(`/admin/trader/${item.id}/relation`)}
                />
              </Tooltip>
            </div>
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ApplicationUserDto>),
  ] as TableColumnDefinition<ApplicationUserDto>[];
